// Decisão de entrada da tela /conexao-caixa, fora do router para poder ser testada
// sem carregar as ~50 views que router.js importa.
//
// A tela é CONFIGURAÇÃO da integração, e por isso exige `gerenciar` — a mesma
// permissão que a aba equivalente em Parâmetros já exigia. A rota direta não
// exigia: bastava digitar a URL para ver as opções.
//
// Quem tem só `ConexaoCaixas.relatorios` importa o resumo TFL pelo modal do caixa
// e não passa por aqui. Esse é o ponto de ter separado as duas permissões: dar
// gerenciar só para destravar a importação abriria esta tela junto.
//
// @param {object} getters   getters do store (contratado + permissão)
// @param {boolean} autenticado  há token da empresa atual no localStorage
// @returns {null|string|object} null libera; senão, o destino do redirecionamento
export function destinoConexaoCaixa(getters, autenticado) {
  if (!autenticado) {
    return "/login";
  }

  // Motivos diferentes, mensagens diferentes: sem o app é assunto de plano, e
  // quem lê resolve contratando; sem permissão é assunto do supervisor.
  if (!getters.conexaoCaixaContratado) {
    return { path: "/dashboard", query: { modulo_bloqueado: "conexao-caixa" } };
  }

  if (!getters.temPermissaoConexaoCaixaGerenciar) {
    return { path: "/dashboard", query: { sem_permissao: "conexao-caixa" } };
  }

  return null;
}
